import React from 'react'
import { CircleAlert } from 'lucide-react'
import { tokens } from '../../../assets/tokens'

const icon = props => <CircleAlert size={20} color={tokens.color.warning.main} {...props} />

export default icon
